import { jsxs as d, Fragment as j, jsx as e } from "react/jsx-runtime";
import E, { useRef as F, useState as O, useEffect as G } from "react";
import { u as l } from "./index-6a632112.mjs";
import { Button as P } from "./button.js";
import { M as D, a as L, b as U, c as V } from "./modalMixedStructure.modalWindow-3bb1e4ef.mjs";
import { Badge as J } from "./badge.js";
import { S as K } from "./cancelClose-87fdf326.mjs";
import { S as Q } from "./caretDown-8ff83493.mjs";
import { S as X } from "./caretUp-e6db3a6f.mjs";
import { s as o, b as $, r as y, d as W, a as k, e as R } from "./themes-5f0b3c3d.mjs";
import { l as I } from "./lineHeights-72d3110c.mjs";
import { useWindowDimensions as Y } from "./useWindowDimensions.js";
import { IconButton as Z } from "./iconButton.js";
import "./textStyles-42cab346.mjs";
import "./fontWeights-a25f8f91.mjs";
import "./accessibility.js";
import "react-dom";
import "./zIndices-d07533f3.mjs";
import "./closeButton.js";
import "./index-c8707610.mjs";
import "./tslib.es6-59e1c9d8.mjs";
import "./superScript-393c70dc.mjs";
import "./disclosure.js";
import "./hTag-40b23797.mjs";
import "./types-b577bf77.mjs";
const tt = l.span`
  width: fit-content;
  height: ${o["8x"]};
  display: flex;
  border: ${$["1x"]} solid
    ${(t) => t.theme.components.filters.borderColor};
  border-radius: ${y["2x"]};
  user-select: none;
  box-sizing: border-box;

  ${(t) => t.$isDisabled ? `
        background: ${t.theme.components.filters.disabledBackground} !important;
        cursor: not-allowed;
        color: ${t.theme.components.filters.disabledColor};
       
        ` : `
        background: ${t.theme.components.filters.defaultBackground};
        cursor: pointer;
        color: ${t.theme.components.filters.defaultColor};`}

  font-family: ${W.body};
  font-size: ${k.xsmall};
  font-style: normal;
  font-weight: ${R.medium.S.fontWeight};
  line-height: ${I.small};

  &:hover {
    background: ${(t) => t.theme.components.filters.hoverBackground};
  }

  ${(t) => t.$isActive && !t.$isDisabled && `
    color: ${t.theme.components.filters.activeColor};
    background: ${t.theme.components.filters.activeBackground};
    border: ${$["1x"]} solid ${t.theme.components.filters.activeBorderColor};
     border-radius: ${y["2x"]};
  `}

  &:focus-visible {
    outline: ${({ $isDisabled: t, theme: s }) => !t && `${$["2x"]} solid ${s.components.tabs.tabFocusRing}`};
    border-radius: ${y["2x"]};
    outline-offset: 2px;
  }
`, et = l.span`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: ${o["1x"]};
  padding: ${o["1x"]} ${o["3x"]};
`, ot = l.div`
  display: flex;

  svg,
  img {
    width: ${o["4x"]};
    height: ${o["4x"]};
  }
`, it = l.div`
  padding: 5px;
  display: flex;
  align-items: center;
  column-gap: ${o["2x"]};
  row-gap: ${o["3x"]};
  flex-wrap: wrap;
  max-height: 80px;
  overflow: hidden;
  position: relative;
`, nt = l.div`
  padding: 5px;
  display: flex;
  align-items: center;
  column-gap: ${o["2x"]};
  row-gap: ${o["3x"]};
  flex-wrap: wrap;
`, _ = l.div`
  display: flex;
  align-items: center;
  color: ${(t) => t.theme.components.chip.labelColor};
  font-family: ${W.body};
  font-size: ${k.xsmall};
  font-weight: ${R.medium.S.fontWeight};
  line-height: ${I.small};
  min-height: 34px;
`, rt = l(Z)`
  height: ${o["6x"]};
  width: ${o["6x"]};
  &:focus-visible {
    outline-offset: unset !important;
  }
`, lt = l.div`
  display: flex;
  align-items: center;
  position: absolute;
  right: 10px;
  bottom: 5px;
  margin-left: ${o["2x"]};
  gap: ${o["2x"]};
  min-height: 33.11px;
  .separator {
    cursor: default;
  }
`, st = l.span`
  pointer-events: none;
  height: ${o["5x"]};
`, b = l.div`
  color: ${(t) => t.theme.components.chip.buttonColor};
  font-family: ${W.body};
  font-size: ${k.xsmall};
  font-weight: ${R.medium.S.fontWeight};
  line-height: ${I.small};
  cursor: pointer;
  &:focus-visible {
    outline: ${({ theme: t }) => `${$["2x"]} solid ${t.components.chip.focusRing}`};
    border-radius: ${y["2x"]};
    outline-offset: 2px;
  }
`, Tt = ({
  children: t,
  onClear: s,
  label: p,
  modalProps: m = { title: "Filter Results", buttonText: "Close", idProps: {} },
  chipGroupAccessibilityOption: C
}) => {
  const r = F(null), [f, h] = O(!1), { width: g } = Y(), v = E.Children.count(t), w = () => {
    const a = r?.current?.getBoundingClientRect().bottom, u = r?.current?.getBoundingClientRect().right;
    if (a && u && r?.current) {
      const n = r?.current?.querySelectorAll('[data-type="chip"]'), c = r?.current?.querySelector(".chip-btns"), B = c?.querySelector(".clear-all"), x = c?.querySelector(".show_all"), z = c?.querySelector(".separator");
      x?.setAttribute("style", "display: none;"), z?.setAttribute("style", "display: none;");
      let S = !1;
      r?.current?.scrollHeight > r?.current?.clientHeight && (x?.setAttribute("style", "display: block;"), z?.setAttribute("style", "display: block;"), S = !0);
      let T = !1, A = 0;
      for (let i = 0; i < n.length; i++)
        n[i].removeAttribute("style"), n[i]?.getAttribute("tabIndex") && n[i]?.setAttribute("tabIndex", "0"), !T && n[i]?.getBoundingClientRect().bottom > a && (T = !0, A = i - 1);
      let q;
      if (S) {
        q = n[A - 1];
        for (let i = A; i < n.length; i++)
          n[i]?.setAttribute("style", "visibility: hidden"), n[i]?.setAttribute("tabIndex", "-1");
        M(q, c, u);
      }
      const H = B?.getBoundingClientRect().width;
      if (!S && H) {
        const i = n[n.length - 1]?.getBoundingClientRect().right, N = u - i;
        c?.setAttribute(
          "style",
          `right: ${N - H - 8}px`
        );
      }
    }
  }, M = (a, u, n) => {
    const c = u?.getBoundingClientRect().width, B = a?.getBoundingClientRect().right, x = n - B;
    c && u?.setAttribute(
      "style",
      `right: ${x - c - 8}px`
    );
  };
  return G(() => {
    w();
  }, [t, g]), /* @__PURE__ */ d(j, { children: [
    /* @__PURE__ */ d(it, { ref: r, children: [
      p && /* @__PURE__ */ e(_, { "data-type": "chip-label", children: p }),
      t,
      /* @__PURE__ */ d(lt, { className: "chip-btns", children: [
        /* @__PURE__ */ e(
          b,
          {
            onClick: s,
            className: "clear-all",
            tabIndex: 0,
            children: "Clear all"
          }
        ),
        /* @__PURE__ */ d(b, { tabIndex: -1, className: "separator", children: [
          " ",
          "|",
          " "
        ] }),
        /* @__PURE__ */ d(
          b,
          {
            className: "show_all",
            onClick: () => {
              h(!0);
            },
            tabIndex: 0,
            children: [
              "Show all (",
              v,
              ")"
            ]
          }
        )
      ] })
    ] }),
    /* @__PURE__ */ d(
      D,
      {
        variant: "large",
        isOpen: f,
        onClose: () => h(!1),
        children: [
          /* @__PURE__ */ e(
            L,
            {
              idProps: m.idProps,
              accessibilityOptions: C?.modalHeaderAccessibilityOptions,
              onClose: () => h(!1),
              children: m.title
            }
          ),
          /* @__PURE__ */ e(U, { children: /* @__PURE__ */ d(nt, { children: [
            p && /* @__PURE__ */ e(_, { children: p }),
            f && t,
            /* @__PURE__ */ e(b, { onClick: s, className: "clear-all", children: "Clear all" })
          ] }) }),
          /* @__PURE__ */ e(V, { placement: "right", children: /* @__PURE__ */ e(P, { onClick: () => h(!1), children: m.buttonText }) })
        ]
      }
    )
  ] });
}, qt = ({
  variant: t,
  isDisabled: s = !1,
  children: p,
  onClick: m,
  isRadio: C,
  leadingIcon: r,
  badgeProps: f = {},
  isActive: h = !1,
  onDelete: g,
  isOpen: v = !1
}) => {
  const w = t === "toggle";
  return /* @__PURE__ */ e(
    tt,
    {
      $isDisabled: s,
      onClick: (a) => {
        s || m && m(a, {
          type: t,
          label: p,
          values: [],
          isActive: !h
        });
      },
      $isActive: h,
      tabIndex: 0,
      "data-type": "chip",
      children: /* @__PURE__ */ d(et, { children: [
        r && /* @__PURE__ */ e(ot, { children: r }),
        /* @__PURE__ */ e("span", { children: p }),
        f?.value && !C && /* @__PURE__ */ e(J, { ...f }),
        g && /* @__PURE__ */ e(
          rt,
          {
            "data-testid": "close_btn",
            isDisabled: s,
            onClick: (a) => {
              s || (a.stopPropagation(), g());
            },
            tabIndex: 0,
            size: "medium",
            variant: "ghost",
            icon: /* @__PURE__ */ e(K, { height: "20px", width: "20px" })
          }
        ),
        !w && /* @__PURE__ */ e(st, { children: v ? /* @__PURE__ */ e(X, { height: "20px", width: "20px" }) : /* @__PURE__ */ e(Q, { height: "20px", width: "20px" }) })
      ] })
    }
  );
};
export {
  qt as Chip,
  Tt as ChipGroup
};
